export default function PresentationCTA() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-10 text-center">
        <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-3xl p-12">
          <div className="w-14 h-14 flex items-center justify-center bg-brand-500/20 rounded-2xl mx-auto mb-6">
            <i className="ri-phone-line text-brand-400 text-2xl"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-black text-white mb-4">
            Besoin d'un devis ou d'une intervention ?
          </h2>
          <p className="text-gray-400 text-base mb-8 max-w-xl mx-auto">
            Notre équipe est disponible du lundi au vendredi de 8h à 18h, et 24h/24 pour les urgences. Contactez-nous pour un devis gratuit et sans engagement.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a
              href="tel:+41764803188"
              className="inline-flex items-center gap-2 bg-brand-500 hover:bg-brand-600 text-white font-bold px-8 py-3.5 rounded-xl transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-fill"></i>
              +41 76 480 31 88
            </a>
            <a
              href="tel:+41765654203"
              className="inline-flex items-center gap-2 bg-teal-500 hover:bg-teal-600 text-white font-bold px-8 py-3.5 rounded-xl transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-fill"></i>
              +41 76 565 42 03
            </a>
            <a
              href="mailto:info@casarenovaplus.ch"
              className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 border border-white/20 text-white font-semibold px-8 py-3.5 rounded-xl transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line"></i>
              info@casarenovaplus.ch
            </a>
          </div>
          <p className="text-gray-500 text-xs mt-6">
            Austrasse 95 · 3176 Neuenegg · Suisse
          </p>
        </div>
      </div>
    </section>
  );
}
